import { Observable, throwError } from 'rxjs';
//Angular
import { HttpErrorResponse, HttpEvent, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
//Services
import { AppInformationService } from '../service/app-info.service';
import { AppService } from '../service/app.service';
import { BroadcastService } from '../service/broadcast.service';
import { RoleService } from '../service/role.services';
import { ErrorFactoryService } from '../service/error-factory.service';
//Utils
import { ObjectUtils } from '../utils/object.utils';
import { AUTHACTIONS } from './role.model';
//Models
import { ToasterType } from './toast-type.model';
import { ConnectionService } from 'ng-connection-service';
import { ERROR_TYPE } from '../error-track/model/error-code.model';

export class HttpRequestModel {
	protected isConnected: boolean;

	constructor(
		protected router: Router,
		protected connectionService: ConnectionService,
		protected broadcastService: BroadcastService,
		protected roleService: RoleService,
		protected errorFactoryService: ErrorFactoryService,
		protected appInfo: AppInformationService,
		protected appService: AppService
	) {
		this.isConnected = true;
		this.connectionService.monitor().subscribe((isConnected) => {
			this.isConnected = isConnected;
		});
	}

	protected onSuccessRequest(event: HttpEvent<any>): any {
		if (event instanceof HttpResponse) {
			const httpResponse: HttpResponse<any> = event.clone();
			// Catch the App Version:
			const appVersion = httpResponse.headers.get('app-version');
			let currentVersion;
			if (this.appInfo.appName && this.appInfo.checkAppInfo) {
				currentVersion = this.appInfo.version;
			}
			if (currentVersion && appVersion !== currentVersion.tag && appVersion !== null) {
				this.broadcastService.broadcast({
					name: ToasterType.UPDATE_APP,
					event: {
						version: appVersion,
					},
				});
			}
			return httpResponse.clone();
		}
	}

	protected onErrorRequest(err: HttpErrorResponse): Observable<any> {
		const skipToast = ObjectUtils.containsPattern(err.url, this.appService.getToasterExceptions());

		if (this.isConnected === false) {
			this.broadcastService.broadcast({
				name: ToasterType.ERROR,
				event: {
					error: 'No Internet access, please check your network connection.',
				},
			});
			return throwError(err);
		}

		let errorMessage = err.message;
		if (err && err.status === 401) {
			// if something goes wrong with the redirection
			this.roleService.unAuthSetValues(AUTHACTIONS.SESSIONEXPIRE);
		}

		// not found
		if (err && err.status === 404) {
			this.roleService.notFoundAction(err.url, this.appInfo.currentmodule, err.status);
		}

		//  don't have enough permissions
		if (err && err.status === 403) {
			this.roleService.notFoundAction(err.url, this.appInfo.currentmodule, err.status);
		}

		// friendly message for server error
		if ((err && err.status === 502) || (err && err.status === 500)) {
			errorMessage = 'Something went wrong please try again';
		}

		// normally the server handles this response and sent a format message
		if (err && err.status === 400) {
			const { error } = err;
			errorMessage = error.message || error.error;
			const changeRoute = this.appService.getChangeRouteOnError(this.appInfo.currentmodule, errorMessage);
			if (changeRoute.changeRoute) {
				this.router.navigate([`${changeRoute.path}`, changeRoute.routerOptions]).catch((e) => console.warn(e));
			}
		}

		//  Swallow all notifications on this list: 412
		if (err && err.status !== 412 && !skipToast) {
			this.broadcastService.broadcast({
				name: ToasterType.ERROR,
				event: {
					error: errorMessage,
				},
			});
		}
		return throwError(err);
	}
}
